import { IEntity } from '@/base/core/iEntity';
export class TopNavigationModel implements IEntity {
    currentSiteId!: any;
    originalUrl!: any;
}